import { get } from 'lodash';
import { useFormContext } from 'react-hook-form';

import { Typography, Card, Space } from '@sravni/react-design-system';
import {
  AgreementAdvertisingCheckbox,
  GiftBanner,
  AgreementPersonalDataCheckbox,
  SubmitButton,
} from '@sravni/react-silent-authentication-form';

import { AUTH_SCREEN_NAME } from 'entities/Authentication/config/screenName';
import { AuthenticationTexts } from 'entities/Authentication/config/texts';
import type { AuthScreenProps } from 'entities/Authentication/types';

import styles from './AuthConsentsScreen.module.scss';

export function AuthConsentsScreen({ updateScreen }: AuthScreenProps) {
  const {
    formState: { errors },
  } = useFormContext();

  const error = get(errors, 'agreementPersonalData');

  return (
    <div
      className={styles.sheetBackdrop}
      onClick={() => {
        updateScreen(AUTH_SCREEN_NAME.INITIAL);
      }}
    >
      <div className={styles.sheet} onClick={(e) => e.stopPropagation()}>
        <Typography.Heading level={3} className="h-mb-16">
          {AuthenticationTexts.ConsentsScreen.title}
        </Typography.Heading>
        <Card color="dark">
          <Space direction="column" size={8}>
            <Card color="light" variant="primary">
              <AgreementAdvertisingCheckbox />
            </Card>
            <GiftBanner>
              <AgreementPersonalDataCheckbox asListItem />
              {error?.message ? (
                <Typography.Text size={12} className={styles.error}>
                  {error.message}
                </Typography.Text>
              ) : null}
            </GiftBanner>
          </Space>
        </Card>
        <SubmitButton size={60} type="submit">
          {AuthenticationTexts.ConsentsScreen.buttonText}
        </SubmitButton>
      </div>
    </div>
  );
}
